// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3mblC","title":"AfterFrontImage_title__2WAAk"};